import React, { useState, useEffect, useContext, useRef } from "react";
import "../../../../constants/report.css";
import axios from "axios";
import { AuthContext } from "../../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../../contexts/ContextProvider";
import { Loader } from "../../../../components";
import { formatDate } from "../../../../constants/helper";
import {
  Box,
  ButtonGroup,
  Button,
  Autocomplete,
  TextField,
} from "@mui/material";
import { Container, Form, Row, Col, Table } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";
import { useDownloadExcel } from "react-export-table-to-excel";
import SearchIcon from "@mui/icons-material/Search";
import PrintIcon from "@mui/icons-material/Print";
import { useReactToPrint } from "react-to-print";
import useScreenWidth from "../../../../hooks/useScreenWidth";

const LaporanTotalHutang = () => {
  const screenSize = useScreenWidth();
  const tableRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const reportTemplateRef = useRef(null);
  let nowDate = new Date();
  let [sampaiTanggal, setSampaiTanggal] = useState(
    new Date(user.tutupperiode.sampaiTanggal)
  );
  let [dariTanggal, setDariTanggal] = useState(
    new Date(user.tutupperiode.dariTanggal)
  );
  const [kodeCabang, setKodeCabang] = useState("");
  const [namaCabang, setNamaCabang] = useState("");
  const [kodeSupplier, setKodeSupplier] = useState("");

  const [cabangs, setCabangs] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [persenLoading, setPersenLoading] = useState("0");
  const [lapSaldoHutangs, setLapSaldoHutangs] = useState([]);
  const [previewPdf, setPreviewPdf] = useState(false);
  const [isCetakExcel, setIsCetakExcel] = useState(false);
  const [error, setError] = useState(false);

  let cabangOptions = cabangs.map((cabang) => ({
    label: `${cabang.id} - ${cabang.namaCabang}`,
    id: `${cabang.id} - ${cabang.namaCabang}`,
  }));

  let supplierOptions = suppliers.map((supplier) => ({
    label: `${supplier.kodeSupplier} - ${supplier.namaSupplier}`,
  }));

  useEffect(() => {
    getSupplierData();
  }, []);

  const getSupplierData = async () => {
    const response = await axios.post(`${tempUrl}/suppliers`, {
      _id: user.id,
      token: user.token,
    });
    setSuppliers(response.data);
  };

  const generatePDF = useReactToPrint({
    content: () => reportTemplateRef.current,
    documentTitle: "LaporanTotalHutang",
  });

  const tampilPdf = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      setLoading(true);
      let tempPersenLoading = parseInt(persenLoading);

      setTimeout(() => {
        tempPersenLoading += 40;
        setPersenLoading(tempPersenLoading.toString());
      }, "1000");

      let laporanTotalHutang = await axios.post(
        `${tempUrl}/laporanTotalHutang`,
        {
          dariTanggal,
          sampaiTanggal,
          kodeSupplier: kodeSupplier.split(" ", 1)[0],
          kodeCabang,
          _id: user.id,
          token: user.token,
        }
      );
      setLapSaldoHutangs(laporanTotalHutang.data);
      setPreviewPdf(!previewPdf);
      setLoading(false);
      setTimeout(() => {
        tempPersenLoading = 0;
        setPersenLoading(tempPersenLoading.toString());
      }, "2000");
    }
  };

  useEffect(() => {
    getCabangsData();
    if (user.tipeUser !== "OWNER/DIREKSI") {
      setKodeCabang(user.cabang.id);
      setNamaCabang(`${user.cabang.id} - ${user.cabang.namaCabang}`);
    }
  }, []);

  const getCabangsData = async () => {
    const response = await axios.post(`${tempUrl}/cabangs`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setCabangs(response.data);
  };

  const tableText = {
    letterSpacing: "0.01px",
  };

  const textBold = {
    fontWeight: 700,
    border: "1px solid black",
  };

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  const textNumberRight = {
    textAlign: "right",
    border: "1px solid black",
  };

  const textNumberRightBold = {
    textAlign: "right",
    fontWeight: 700,
    border: "1px solid black",
  };

  const list = [];

  // let tempTotalSaldo = 0;

  // Object.entries(lapSaldoHutangs).map(([supplierTitle, stokRows]) => {
  //   list.push(
  //     <tr style={{ ...tableText, fontWeight: "bold" }}>
  //       <td
  //         style={{ paddingLeft: "15px", border: "1px solid black" }}
  //         colSpan={5}
  //       >
  //         Supplier :{supplierTitle}
  //       </td>
  //     </tr>
  //   );

  //   let tempSubtotalSaldo = 0;

  //   stokRows.map((row, index) => {
  //     let saldo = row.total - row.totalBayar;
  //     tempSubtotalSaldo += saldo;
  //     tempTotalSaldo += saldo;
  //     list.push(
  //       <tr style={tableText}>
  //         <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
  //           {row.noNotaPembelian}
  //         </td>
  //         <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
  //           {row.keterangan}
  //         </td>
  //         <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
  //           {formatDate(row.tglPembelian)}
  //         </td>
  //         <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
  //           {formatDate(row.tglJatuhTempo)}
  //         </td>
  //         <td style={textNumberRight}>
  //           {isCetakExcel === false
  //             ? (row.total - row.totalBayar).toLocaleString("en-EN")
  //             : row.total - row.totalBayar}
  //         </td>
  //       </tr>
  //     );
  //   });

  //   list.push(
  //     <tr style={{ ...tableText, fontWeight: "bold" }}>
  //       <td
  //         style={{ paddingLeft: "15px", border: "1px solid black" }}
  //         colSpan={4}
  //       >
  //         Sub Total : {supplierTitle}
  //       </td>
  //       <td style={textNumberRight}>
  //         {isCetakExcel === false
  //           ? tempSubtotalSaldo.toLocaleString("en-EN")
  //           : tempSubtotalSaldo}
  //       </td>
  //     </tr>
  //   );
  // });

  // list.push(
  //   <tr style={{ ...tableText, fontWeight: "bold" }}>
  //     <td
  //       style={{ paddingLeft: "15px", border: "1px solid black" }}
  //       colSpan={4}
  //     >
  //       Total :
  //     </td>
  //     <td style={textNumberRight}>
  //       {isCetakExcel === false
  //         ? tempTotalSaldo.toLocaleString("en-EN")
  //         : tempTotalSaldo}
  //     </td>
  //   </tr>
  // );

  let tempTotalSubtotalSaldoAwal = 0;
  let tempTotalSubtotalPenambahanPembelian = 0;
  let tempTotalSubtotalPenambahanLainLain = 0;
  let tempTotalSubtotalPenguranganPenjualan = 0;
  let tempTotalSubtotalPenguranganLainLain = 0;
  let tempTotalSaldoAkhir = 0;

  Object.entries(lapSaldoHutangs).map(([groupTitle, stokRows]) => {
    list.push(
      <tr style={{ ...tableText, fontWeight: "bold" }}>
        <td
          style={{ paddingLeft: "15px", border: "1px solid black" }}
          colSpan={9}
        >
          Grup : {groupTitle}
        </td>
      </tr>
    );

    let tempSubtotalSubtotalSaldoAwal = 0;
    let tempSubtotalSubtotalPenambahanPembelian = 0;
    let tempSubtotalSubtotalPenambahanLainLain = 0;
    let tempSubtotalSubtotalPenguranganPenjualan = 0;
    let tempSubtotalSubtotalPenguranganLainLain = 0;
    let tempSubtotalSaldoAkhir = 0;

    stokRows.map((row, index) => {
      tempSubtotalSubtotalSaldoAwal += row.subtotalSaldoAwal;
      tempSubtotalSubtotalPenambahanPembelian +=
        row.subtotalPenambahanPembelian;
      tempSubtotalSubtotalPenambahanLainLain += row.subtotalPenambahanLainLain;
      tempSubtotalSubtotalPenguranganPenjualan +=
        row.subtotalPenguranganPenjualan;
      tempSubtotalSubtotalPenguranganLainLain +=
        row.subtotalPenguranganLainLain;
      tempSubtotalSaldoAkhir += row.subtotalSaldoAkhir;

      tempTotalSubtotalSaldoAwal += row.subtotalSaldoAwal;
      tempTotalSubtotalPenambahanPembelian += row.subtotalPenambahanPembelian;
      tempTotalSubtotalPenambahanLainLain += row.subtotalPenambahanLainLain;
      tempTotalSubtotalPenguranganPenjualan += row.subtotalPenguranganPenjualan;
      tempTotalSubtotalPenguranganLainLain += row.subtotalPenguranganLainLain;
      tempTotalSaldoAkhir += row.subtotalSaldoAkhir;

      list.push(
        <tr style={tableText}>
          <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
            {index + 1}
          </td>
          <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
            {row.supplierTitle}
          </td>
          <td style={textNumberRight}>
            {isCetakExcel === false
              ? row.subtotalSaldoAwal.toLocaleString("en-EN")
              : row.subtotalSaldoAwal}
          </td>
          <td style={textNumberRight}>
            {isCetakExcel === false
              ? row.subtotalPenambahanPembelian.toLocaleString("en-EN")
              : row.subtotalPenambahanPembelian}
          </td>
          <td style={textNumberRight}>
            {isCetakExcel === false
              ? row.subtotalPenambahanLainLain.toLocaleString("en-EN")
              : row.subtotalPenambahanLainLain}
          </td>
          <td style={textNumberRight}>
            {isCetakExcel === false
              ? row.subtotalPenguranganPenjualan.toLocaleString("en-EN")
              : row.subtotalPenguranganPenjualan}
          </td>
          <td style={textNumberRight}>
            {isCetakExcel === false
              ? row.subtotalPenguranganLainLain.toLocaleString("en-EN")
              : row.subtotalPenguranganLainLain}
          </td>
          <td style={textNumberRight}>
            {isCetakExcel === false
              ? row.subtotalSaldoAkhir.toLocaleString("en-EN")
              : row.subtotalSaldoAkhir}
          </td>
        </tr>
      );
    });

    list.push(
      <tr style={{ ...tableText, fontWeight: "bold" }}>
        <td
          style={{ paddingLeft: "15px", border: "1px solid black" }}
          colSpan={2}
        >
          Sub Total : {groupTitle}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? tempSubtotalSubtotalSaldoAwal.toLocaleString("en-EN")
            : tempSubtotalSubtotalSaldoAwal}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? tempSubtotalSubtotalPenambahanPembelian.toLocaleString("en-EN")
            : tempSubtotalSubtotalPenambahanPembelian}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? tempSubtotalSubtotalPenambahanLainLain.toLocaleString("en-EN")
            : tempSubtotalSubtotalPenambahanLainLain}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? tempSubtotalSubtotalPenguranganPenjualan.toLocaleString("en-EN")
            : tempSubtotalSubtotalPenguranganPenjualan}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? tempSubtotalSubtotalPenguranganLainLain.toLocaleString("en-EN")
            : tempSubtotalSubtotalPenguranganLainLain}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? tempSubtotalSaldoAkhir.toLocaleString("en-EN")
            : tempSubtotalSaldoAkhir}
        </td>
      </tr>
    );
  });

  list.push(
    <tr style={{ ...tableText, fontWeight: "bold" }}>
      <td
        style={{ paddingLeft: "15px", border: "1px solid black" }}
        colSpan={2}
      >
        Grand Total :
      </td>
      <td style={textNumberRight}>
        {isCetakExcel === false
          ? tempTotalSubtotalSaldoAwal.toLocaleString("en-EN")
          : tempTotalSubtotalSaldoAwal}
      </td>
      <td style={textNumberRight}>
        {isCetakExcel === false
          ? tempTotalSubtotalPenambahanPembelian.toLocaleString("en-EN")
          : tempTotalSubtotalPenambahanPembelian}
      </td>
      <td style={textNumberRight}>
        {isCetakExcel === false
          ? tempTotalSubtotalPenambahanLainLain.toLocaleString("en-EN")
          : tempTotalSubtotalPenambahanLainLain}
      </td>
      <td style={textNumberRight}>
        {isCetakExcel === false
          ? tempTotalSubtotalPenguranganPenjualan.toLocaleString("en-EN")
          : tempTotalSubtotalPenguranganPenjualan}
      </td>
      <td style={textNumberRight}>
        {isCetakExcel === false
          ? tempTotalSubtotalPenguranganLainLain.toLocaleString("en-EN")
          : tempTotalSubtotalPenguranganLainLain}
      </td>
      <td style={textNumberRight}>
        {isCetakExcel === false
          ? tempTotalSaldoAkhir.toLocaleString("en-EN")
          : tempTotalSaldoAkhir}
      </td>
    </tr>
  );

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "LaporanTotalHutang",
    sheet: "LaporanTotalHutang",
  });

  if (loading) {
    return <Loader persenLoading={persenLoading} />;
  }

  return (
    <Container>
      <h3>Laporan</h3>
      <h5 style={{ fontWeight: 400 }}>Laporan Total Hutang</h5>
      <hr />
      <Box sx={spacingTop}>
        <Form onSubmit={tampilPdf}>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Cabang :
                </Form.Label>
                <Col sm="8">
                  {user.tipeUser === "OWNER/DIREKSI" ? (
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={cabangOptions}
                      renderInput={(params) => (
                        <TextField
                          error={error && kodeCabang.length === 0 && true}
                          size="small"
                          placeholder="SEMUA CABANG"
                          {...params}
                        />
                      )}
                      onChange={(e, value) => {
                        if (value) {
                          setKodeCabang(value.id.split(" ", 1)[0]);
                          setNamaCabang(value.id);
                        } else {
                          setKodeCabang("");
                          setNamaCabang("");
                        }
                        setPreviewPdf(false);
                      }}
                      defaultValue={kodeCabang}
                    />
                  ) : (
                    <Form.Control value={kodeCabang} disabled readOnly />
                  )}
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Dari :
                </Form.Label>
                <Col sm="8">
                  <DatePicker
                    required
                    dateFormat="dd/MM/yyyy"
                    selected={dariTanggal}
                    customInput={<Form.Control required />}
                    onChange={(date) => {
                      setDariTanggal(date);
                      setPreviewPdf(false);
                    }}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Sampai :
                </Form.Label>
                <Col sm="8">
                  <DatePicker
                    required
                    dateFormat="dd/MM/yyyy"
                    selected={sampaiTanggal}
                    customInput={<Form.Control required />}
                    onChange={(date) => {
                      setSampaiTanggal(date);
                      setPreviewPdf(false);
                    }}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Supplier :
                </Form.Label>
                <Col sm="8">
                  <Autocomplete
                    size="small"
                    disablePortal
                    id="combo-box-demo"
                    options={supplierOptions}
                    renderInput={(params) => (
                      <TextField
                        error={error && kodeSupplier.length === 0 && true}
                        placeholder="SEMUA SUPPLIER"
                        size="small"
                        {...params}
                      />
                    )}
                    onChange={(e, value) => {
                      if (value) {
                        setKodeSupplier(value.label);
                      } else {
                        setKodeSupplier("");
                      }
                      setPreviewPdf(false);
                    }}
                    value={kodeSupplier}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Button
            variant="contained"
            startIcon={<SearchIcon />}
            type="submit"
            style={{ marginTop: "20px" }}
          >
            LIHAT
          </Button>
        </Form>
      </Box>

      {previewPdf && (
        <div style={{ marginTop: "10px" }}>
          <ButtonGroup variant="outlined" color="secondary">
            <Button startIcon={<PrintIcon />} onClick={generatePDF}>
              PDF
            </Button>
            <Button
              startIcon={<SearchIcon />}
              onClick={() => {
                setIsCetakExcel(true);
                setTimeout(() => {
                  onDownload();
                }, "1000");
              }}
            >
              Excel
            </Button>
          </ButtonGroup>
        </div>
      )}
      <div ref={reportTemplateRef} id="content" style={pdfContainer}>
        <div style={{ visibility: previewPdf === true ? "visible" : "hidden" }}>
          <p>
            {setting.namaPerusahaan} - {setting.alamatPerusahaan}
          </p>
          <p>({setting.kabupatenPerusahaan})</p>
          <p>{setting.kotaPerusahaan}</p>
          <p>NO. TELP. {setting.teleponPerusahaan}</p>
          <p>
            Dicetak Oleh: {user.username} | Tanggal:
            {` ${nowDate.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(nowDate.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${nowDate.getFullYear()} `}{" "}
            | Jam:{" "}
            {` ${nowDate.getHours().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}:${(nowDate.getMinutes() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}:${nowDate.getSeconds().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })} `}
          </p>
          <h5 style={{ textAlign: "center", fontWeight: "700" }}>
            Laporan Total Hutang
          </h5>
          <p>
            Dari Tanggal :
            {` ${dariTanggal.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(dariTanggal.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${dariTanggal.getFullYear()}`}
          </p>
          <p>
            Sampai Tanggal :
            {` ${sampaiTanggal.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(sampaiTanggal.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${sampaiTanggal.getFullYear()}`}
          </p>
          <p>Supplier : {kodeSupplier ? kodeSupplier : "SEMUA"}</p>
          <p>Cabang : {namaCabang}</p>
          <p></p>
          <table class="styled-table" ref={tableRef}>
            <thead>
              <tr>
                <th style={{ border: "1px solid black" }} rowSpan={2}>
                  NO.
                </th>
                <th style={{ border: "1px solid black" }} rowSpan={2}>
                  SUPPLIER
                </th>
                <th style={{ border: "1px solid black" }} rowSpan={2}>
                  SALDO AWAL
                </th>
                <th
                  style={{ border: "1px solid black", textAlign: "center" }}
                  colSpan={2}
                >
                  PENAMBAHAN
                </th>
                <th
                  style={{ border: "1px solid black", textAlign: "center" }}
                  colSpan={2}
                >
                  PENGURANGAN
                </th>
                <th style={{ border: "1px solid black" }} rowSpan={2}>
                  SALDO AKHIR
                </th>
              </tr>
              <tr>
                <th style={{ border: "1px solid black" }}>PEMBELIAN</th>
                <th style={{ border: "1px solid black" }}>LAIN-LAIN</th>
                <th style={{ border: "1px solid black" }}>PEMBAYARAN</th>
                <th style={{ border: "1px solid black" }}>RETUR</th>
              </tr>
            </thead>
            <tbody>{list}</tbody>
          </table>
        </div>
      </div>
    </Container>
  );
};

export default LaporanTotalHutang;

const spacingTop = {
  mt: 4,
};

const pdfContainer = {
  padding: "20px",
  letterSpacing: "0.01px",
  fontSize: "10px",
  fontFamily: "sans-serif",
  width: "1000px",
};

const colorRed = {
  color: "red",
};
